import { aliases, mdi } from 'vuetify/iconsets/mdi';
import { light, dark } from './themes';
import { componentDefaults } from './componentDefaults';
import { componentAliases } from './componentAliases';

/**
 * All apps should use the following line otherwise components will lack of vuetify style
 */
import '@mdi/font/css/materialdesignicons.css';

export const vuetifyOptions = {
  global: {
    ripple: false,
  },
  defaults: {
    ...componentDefaults,
  },
  aliases: {
    ...componentAliases,
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light,
      dark,
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...aliases,
    },
    sets: {
      mdi,
    },
  },
};

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    // prettier-ignore
    VBtnOutlined: typeof import('vuetify/components/VBtn')['VBtn'];
    // prettier-ignore
    VBtnTonal: typeof import('vuetify/components/VBtn')['VBtn'];
    // prettier-ignore
    VBtnText: typeof import('vuetify/components/VBtn')['VBtn'];
  }
}
